export default __webpack_public_path__ + "static/media/lion_standup.cb2cde6c.png";